import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import Header from "../../Header";
import Sidebar from "../../Sidebar";
import Footer from "../../Footer";
import AppListDetails from "../apps/AppListDetails";
import UsersDetails from "../user/UsersDetails";
import OrganizationInfo from "./OrganizationInfo";
import { getOrganization } from "../../../redux/actions/OrganizationAction";

const OrganizationDetails = ({ match }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const organizationId = match.params.id;
    const role = useSelector((s) => s.userLogin.userInfo.data.role);
    const organization = useSelector((s) => s?.organizationEdit?.organization);
    const appCount = useSelector((s) => s?.organizationEdit?.appCount);
    const userCount = useSelector((s) => s?.organizationEdit?.userCount);

    const [activeTab, setActiveTab] = useState("Apps");

    useEffect(() => {
        dispatch(getOrganization(organizationId));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="container-scroller">
                <Header />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <Box component="main" className="main-panel" sx={{ display: "flex", flexDirection: "column" }}>
                        <Box sx={{ flex: 1, py: { xs: 2, md: 3 } }}>
                            <Container maxWidth="xl" disableGutters sx={{ px: { xs: 2, md: 3 } }}>
                                <Paper elevation={0} sx={{ p: { xs: 2, md: 3 }, border: "1px solid", borderColor: "divider" }}>
                                    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
                                        <IconButton onClick={() => history.push("/organizations")} size="small" aria-label="Back">
                                            <ArrowBackIcon />
                                        </IconButton>
                                        <Typography variant="h3" component="h1" sx={{ flex: 1, minWidth: 0 }} noWrap>
                                            {organization?.name || "Organization"}
                                        </Typography>
                                    </Stack>

                                    {role === "Super_Admin" && (
                                        <Tabs
                                            value={activeTab}
                                            onChange={(_e, v) => setActiveTab(v)}
                                            sx={{
                                                borderBottom: "1px solid",
                                                borderColor: "divider",
                                                mb: 2,
                                                "& .MuiTab-root": { textTransform: "none", fontWeight: 600, minHeight: 48 },
                                            }}
                                        >
                                            <Tab
                                                value="Apps"
                                                label={
                                                    <Badge badgeContent={appCount || 0} color="primary" sx={{ ".MuiBadge-badge": { right: -18, top: 10 } }}>
                                                        <Box sx={{ pr: 3 }}>Apps</Box>
                                                    </Badge>
                                                }
                                            />
                                            <Tab
                                                value="Users"
                                                label={
                                                    <Badge badgeContent={userCount || 0} color="primary" sx={{ ".MuiBadge-badge": { right: -18, top: 10 } }}>
                                                        <Box sx={{ pr: 3 }}>Users</Box>
                                                    </Badge>
                                                }
                                            />
                                            <Tab value="About" label="About" />
                                        </Tabs>
                                    )}

                                    {activeTab === "Apps" && (
                                        <AppListDetails from="organization" organizationId={organizationId} />
                                    )}
                                    {activeTab === "Users" && (
                                        <UsersDetails from="organization" organizationId={organizationId} />
                                    )}
                                    {activeTab === "About" && (
                                        <OrganizationInfo organizationId={organizationId} />
                                    )}
                                </Paper>
                            </Container>
                        </Box>
                        <Footer />
                    </Box>
                </div>
            </div>
        </>
    );
};

export default OrganizationDetails;
